import React, { Component } from "react";
import { connect } from 'react-redux';
import { activateWebsite } from '../Claim/activatewebsite';
import "../../assets/css/dashboard.css";
import PopupModal from './popups/PopupModal';
import apiInstance from "../apiInstance";
import withRouter from "../../utility/withRouter";

class Backups extends Component {
    constructor(props) {
        super(props);
        this.state = {
            websites: [],
            currentWebsite: "",
            backups: {},
            backupInProgress: false,
            skeletonLoading: true,
            msg: "",
            error: ""
        };
        this.popupRef = React.createRef();
    }

    async componentDidMount() {
        await apiInstance
            .get("/dashboard/websites")
            .then( async (response) => {
                this.setState({ error: "", msg: "" });
                const websites = response.data.websites;
                let currentWebsite = null;

                const storedWebsiteId = localStorage.getItem('currentWebsiteId');
                if(storedWebsiteId) {
                    currentWebsite = websites.find(item => item._id === storedWebsiteId);
                }

                if(!currentWebsite && websites.length > 0) {
                    currentWebsite = websites[0];
                }

                this.setState(() => {
                    return {
                        websites: websites,
                        currentWebsite: currentWebsite,
                    };
                });

                if (currentWebsite) {
                    localStorage.setItem('currentWebsiteId', currentWebsite._id);
                    await apiInstance
                        .get(`/dashboard/backups/${currentWebsite._id}`)
                        .then((response) => {
                            this.setState({ error: "", msg: "" });
                            const backups = response.data.backups;

                            this.setState(() => {
                                return {
                                    backups: backups,
                                };
                            });
                        })
                        .catch((error) => {
                            console.error("Error fetching data:", error);
                            this.setState({ error: error.response?.data?.message || error.message || "Failed to fetch backups." });
                        });
                }
                
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                this.setState({ error: error.response?.data?.message || error.message || "Failed to fetch websites." });
            });
        this.setState({skeletonLoading: false});
    }

    handleCurrentSiteChange = async (e) => {
        this.setState({skeletonLoading: true});

        const selectedSite = e.target.value;
        let siteIndex = 0;
        this.state.websites.map((website, index) =>
            website.siteName === selectedSite ? (siteIndex = index) : ""
        );
        const currentsite = this.state.websites[siteIndex];
        this.setState({ currentWebsite: currentsite });

        if(currentsite) {
            localStorage.setItem('currentWebsiteId', currentsite._id);
        } else {
            localStorage.removeItem('currentWebsiteId');
        }

        await apiInstance
            .get(`/dashboard/backups/${currentsite._id}`)
            .then((response) => {
                this.setState({ error: "", msg: "" });
                const backups = response.data.backups;

                this.setState(() => {
                    return {
                        backups: backups,
                    };
                });
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                this.setState({ error: error.response?.data?.message || "Something went wrong, please try again later." });
            });

        this.setState({skeletonLoading: false});

    }

    startNewBackup = async () => {
        this.setState({backupInProgress: true});
        const siteId = this.state.currentWebsite?._id;
        this.setState({ error: "", msg: "" });

        await apiInstance
            .post(
                `/dashboard/backups/add`,
                {
                    siteData: {
                        siteId: siteId
                    }
                }
            )
            .then((response) => {
                this.setState({ msg: "New backup created successfully." });
                const backups = response.data.backups;
                this.setState(() => {
                    return {
                        backups: backups,
                    };
                });
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                this.setState({ error: error.response?.data?.message || "Something went wrong, please try again later." });
            });
        this.setState({backupInProgress: false});
    }

    deleteBackupHandler = (filename) => {
        this.setState({ error: "", msg: "Backup deleted successfully." });
        this.setState(prev => ({
            backups: {
                manual: prev.backups.manual.filter(b => b.filename !== filename)
            }
        }));
    };

    restoreBackupHandler = async (fileName) => {
        this.setState({ error: "", msg: "Backup restored successfully." });
    }

    updateError = (error) => {
        this.setState({ error: error, msg: "" });
    }

    formatDate(isoString) {
        const date = new Date(isoString);
        const datePart = new Intl.DateTimeFormat(undefined, {
            year: 'numeric',
            month: 'short',
            day: '2-digit'
        }).format(date);

        const timePart = new Intl.DateTimeFormat(undefined, {
            hour: 'numeric',
            minute: '2-digit'
        }).format(date);

        return `${datePart} at ${timePart}`;
    }

    formatBytes(bytes) {
        if (!bytes || bytes === 0) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${units[i]}`;
    }

    activateNow = async (siteId) => {
        try {
            await activateWebsite({
                siteId,
                userEmail: this.props.user?.email
            });
        } catch (err) {
            console.error('Checkout failed:', err.message);
            this.setState({ error: err.message || "Request failed. Please contact us." });
        }
    }

    render() {
        const backups = this.state.backups;
        const websites = Array.isArray(this.state.websites)
            ? this.state.websites
            : [];
        
        const currSiteId = this.state.currentWebsite?._id;
        const currSiteCodeName = this.state.currentWebsite?.siteName;
        const currentWebsite = this.state.currentWebsite;
        const backupInProgressHTML = this.state.backupInProgress;
        const skeletonLoading = this.state.skeletonLoading;
        const {error, msg} = this.state;

        const currSiteSubscriptionStatus = this.state.currentWebsite?.subscription?.status || '-';

        return (
            <>
                {websites?.length > 0 &&
                    <div className="mjs-dash-top">
                        <div className="mjs-dash-top-site-dd">
                            <span>Active Website </span>
                            <select
                                className="mjs-select"
                                value={currSiteCodeName}
                                onChange={this.handleCurrentSiteChange}
                            >
                                {websites.map((website, index) => (
                                    <option
                                        key={website._id}
                                        value={website.siteName}
                                    >
                                        {website.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                }

                <div className="mjs-dash-section">
                    <h4>Backup Management</h4>
                    <p className="mjs-m-0">Manage backups of your website for disaster recovery and peace of mind.</p>

                    {websites?.length > 0 ?
                    <>
                    
                        {error && <p className="mjs_text_error">{error}</p>}
                        {msg && <div className="mjs-message">{msg}</div>}

                        <div className="mjs-dash-sec-card">
                            <div className="mjs-m-0 mjs-row">
                                <div>
                                    <h5>Manual Backups</h5>
                                    <p className="mjs_text_grey mjs-mt-5 mjs-mb-0">You can create up to 3 manual backups any time.</p>
                                </div>
                                <div>
                                    {backupInProgressHTML === true && <i id="mjs-login-spin" className="fa-solid fa-spinner fa-spin mjs-mr-10"></i>}
                                    {
                                    currSiteSubscriptionStatus === "active" ? 
                                        <span className="mjs-btn mjs-btn-primary" onClick={this.startNewBackup}>New Backup</span>
                                        :
                                        <span className="mjs-btn mjs-btn-primary disabled">New Backup</span>
                                    }
                                </div>
                            </div>

                            {
                            skeletonLoading !== false ? 
                                <>
                                    <div className='mjs_pre_skeleton_text mjs-width-15 mjs-mt-5'></div>
                                    <div className='mjs_pre_skeleton_text mjs-width-10'></div>
                                    <div className='mjs_pre_skeleton_text mjs-width-20'></div>
                                </>
                            :
                            currSiteSubscriptionStatus !== "active" ?
                                <div>
                                    <p className="mjs_text_error">
                                        <span className="mjs-mr-5">Backups Are Locked. Activate your website to keep your site safe and restorable at all times.</span>
                                        <span className="mjs-ml-5 mjs-quick-action-link" onClick={() => this.activateNow(currSiteId)}>Activate Now</span>
                                    </p>
                                </div>
                            :
                            backups?.manual?.length > 0 ? (
                                <table className="mjs-table mjs-no-border-pdng">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Type</th>
                                            <th>Size</th>
                                            <th className="mjs-flex-wrapper">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {backups.manual.map((backup) => {
                                            const date = this.formatDate(backup.createdAt) || 'N/A';
                                            const fileName = backup.filename;
                                            const size = this.formatBytes(backup.sizeBytes) || '0 KB';
                                            return (
                                                <tr key={fileName}>
                                                    <td>{date}</td>
                                                    <td>Manual</td>
                                                    <td>{size}</td>
                                                    <td className="mjs-flex-wrapper">
                                                        <span className="mjs-btn" 
                                                            onClick={() => {
                                                                if (this.popupRef.current) {
                                                                    this.popupRef.current.openPopup(
                                                                        "restoreBackup",
                                                                        { backupData: {
                                                                            websiteId: currentWebsite._id,
                                                                            fileName: fileName
                                                                            } 
                                                                        }
                                                                    );
                                                                }
                                                            }}
                                                        >Restore</span>
                                                        <span className="mjs-btn mjs_text_error" 
                                                            onClick={() => {
                                                                if (this.popupRef.current) {
                                                                    this.popupRef.current.openPopup(
                                                                        "deleteBackup",
                                                                        { backupData: {
                                                                            websiteId: currentWebsite._id,
                                                                            fileName: fileName
                                                                            } 
                                                                        }
                                                                    );
                                                                }
                                                            }}
                                                        >Delete</span>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            ) : (
                                <div>
                                    <p>No Manual backups yet!</p>
                                </div>
                            )
                            }
                        </div>

                        <div className="mjs-dash-sec-card">
                            <div className="mjs-m-0">
                                <h5>Daily Backups</h5>
                                <p className="mjs_text_grey mjs-mt-5 mjs-mb-0">Up to 3 recent daily backups we maintain for you.</p>
                            </div>

                            {
                            skeletonLoading !== false ? 
                                <>
                                    <div className='mjs_pre_skeleton_text mjs-width-15 mjs-mt-5'></div>
                                    <div className='mjs_pre_skeleton_text mjs-width-10'></div>
                                    <div className='mjs_pre_skeleton_text mjs-width-20'></div>
                                </>
                            :
                            currSiteSubscriptionStatus !== "active" ?
                                <div>
                                    <p>No Daily backups yet!</p>
                                </div>
                            :
                            backups?.daily?.length > 0 ? (
                                <table className="mjs-table mjs-no-border-pdng">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Type</th>
                                            <th>Size</th>
                                            <th className="mjs-flex-wrapper">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {backups.daily.map((backup) => {
                                            const date = this.formatDate(backup.createdAt) || 'N/A';
                                            const fileName = backup.filename;
                                            const size = this.formatBytes(backup.sizeBytes) || '0 KB';
                                            return (
                                                <tr key={fileName}>
                                                    <td>{date}</td>
                                                    <td>Daily</td>
                                                    <td>{size}</td>
                                                    <td className="mjs-flex-wrapper">
                                                        <span className="mjs-btn" 
                                                            onClick={() => {
                                                                if (this.popupRef.current) {
                                                                    this.popupRef.current.openPopup(
                                                                        "restoreBackup",
                                                                        { backupData: {
                                                                            websiteId: currentWebsite._id,
                                                                            fileName: fileName
                                                                            } 
                                                                        }
                                                                    );
                                                                }
                                                            }}
                                                        >Restore</span>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            ) : (
                                <div>
                                    <p>No daily backups yet!</p>
                                </div>
                            )
                            }
                        </div>

                        <div className="mjs-dash-sec-card">
                            <div className="mjs-m-0">
                                <h5>Weekly Backup</h5>
                                <p className="mjs_text_grey mjs-mt-5 mjs-mb-0">Weekly backup maintained every Sunday.</p>
                            </div>

                            {
                            skeletonLoading !== false ? 
                                <>
                                    <div className='mjs_pre_skeleton_text mjs-width-15 mjs-mt-5'></div>
                                    <div className='mjs_pre_skeleton_text mjs-width-10'></div>
                                    <div className='mjs_pre_skeleton_text mjs-width-20'></div>
                                </>
                            :
                            currSiteSubscriptionStatus !== "active" ?
                                <div>
                                    <p>No Weekly backup yet!</p>
                                </div>
                            :
                            backups?.weekly?.length > 0 ? (
                                <table className="mjs-table mjs-no-border-pdng">
                                    <tbody>
                                        {backups.weekly.map((backup) => {
                                            const date = this.formatDate(backup.createdAt) || 'N/A';
                                            const fileName = backup.filename;
                                            const size = this.formatBytes(backup.sizeBytes) || '0 KB';
                                            return (
                                                <tr key={fileName}>
                                                    <td>{date}</td>
                                                    <td>Weekly</td>
                                                    <td>{size}</td>
                                                    <td className="mjs-flex-wrapper">
                                                        <span className="mjs-btn" 
                                                            onClick={() => {
                                                                if (this.popupRef.current) {
                                                                    this.popupRef.current.openPopup(
                                                                        "restoreBackup",
                                                                        { backupData: {
                                                                            websiteId: currentWebsite._id,
                                                                            fileName: fileName
                                                                            } 
                                                                        }
                                                                    );
                                                                }
                                                            }}
                                                        >Restore</span>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            ) : (
                                <div>
                                    <p>No Weekly backup yet!</p>
                                </div>
                            )
                            }
                        </div>
                    </>
                    :
                    <>
                        {skeletonLoading !== false ? 
                            <div className='mjs_pre_skeleton_text mjs-width-20'></div>
                        :
                            <p className='mjs_text_error'>You don't have any website yet!.</p>
                        }
                    </>
                    }
                </div>
                <PopupModal
                    ref={this.popupRef}
                    deleteBackup={this.deleteBackupHandler}
                    restoreBackup={this.restoreBackupHandler}
                />
            </>
        );
    }


}

const mapStateToProps = (state) => {
    return (
        {
            user: state.currentUser,
        }
    )
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(withRouter(Backups));